import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";

export default function Testimonials() {
    const testimonials = [
        {
            text: `"Amantranaa Caterers transformed our wedding from a beautiful event to an unforgettable celebration. Their attention to detail, impeccable service, and delicious food made our guests rave about the entire experience."`,
            author: "Priya & Amit, Wedding Couple",
        },
        {
            text: `"The team at Amantranaa was incredibly professional and accommodating. Their buffet setup was a hit at our corporate event, and the feedback from our attendees was overwhelmingly positive."`,
            author: "Rahul Sharma, CEO, TechCorp",
        },
        {
            text: `"We had a small intimate gathering, and Amantranaa delivered a personalized menu that perfectly matched our preferences. The presentation and service were impeccable."`,
            author: "Anjali Patel, Birthday Celebrant",
        },
        {
            text: `"Every dish was served with love and precision. The flavors felt authentic yet modern — our engagement guests couldn’t stop talking about the desserts!"`,
            author: "Karan & Neha, Engagement",
        },
        {
            text: `"Their South Indian spread was absolutely divine. From the dosas to the payasam, it reminded us of home, but elevated to perfection."`,
            author: "Suresh & Lakshmi, Traditional Ceremony",
        },
        {
            text: `"Amantranaa’s team went above and beyond to ensure our corporate retreat dinner was flawless. Truly world-class hospitality."`,
            author: "Megha Kapoor, Event Organizer",
        },
    ];

    const [index, setIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setIndex((prev) => (prev + 1) % testimonials.length);
        }, 5000);
        return () => clearInterval(timer);
    }, [testimonials.length]);

    const fade = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
        exit: { opacity: 0, y: -20, transition: { duration: 0.6, ease: "easeIn" } },
    };

    return (
        <section
            id="testimonials"
            className="relative font-[Playfair_Display] overflow-hidden py-28 px-6 md:px-20 text-center"
            style={{
                background: "#FFFFFF",
                color: "#1F2937",
            }}
        >
            {/* Header */}
            <motion.div
                className="flex flex-col items-center mb-12"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
            >
        <span
            className="px-6 py-2 rounded-full text-sm font-semibold tracking-wide mb-4 shadow-md"
            style={{
                background:
                    "linear-gradient(135deg, #D4AF37 0%, #e0c168 50%, #B88A2D 100%)",
                color: "#FFFFFF",
            }}
        >
          TESTIMONIALS
        </span>

                <h2 className="text-4xl md:text-5xl font-semibold mb-3 text-[#1F2937]">
                    What Our Clients Say
                </h2>
                <p className="max-w-2xl mx-auto text-lg italic text-[#4B5563]">
                    Words that inspire our craft.
                </p>
            </motion.div>

            {/* Auto-Rotating Testimonial */}
            <div className="max-w-3xl mx-auto min-h-[280px] flex items-center justify-center relative">
                <AnimatePresence mode="wait">
                    <motion.div
                        key={index}
                        variants={fade}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        className="absolute w-full p-10 rounded-2xl"
                        style={{
                            background: "#F9FAFB",
                            border: "1px solid rgba(212,175,55,0.4)",
                            boxShadow:
                                "0 4px 20px rgba(0,0,0,0.1)",
                        }}
                    >
                        <p className="italic leading-relaxed text-[#4B5563] mb-6 text-lg">
                            {testimonials[index].text}
                        </p>
                        <p className="text-[#D4AF37] font-semibold text-sm">
                            — {testimonials[index].author}
                        </p>
                    </motion.div>
                </AnimatePresence>
            </div>

            {/* Dots Navigation */}
            <div className="flex justify-center mt-10 space-x-3">
                {testimonials.map((_, i) => (
                    <button
                        key={i}
                        onClick={() => setIndex(i)}
                        className={`w-3 h-3 rounded-full transition-all duration-300 ${
                            i === index
                                ? "bg-[#D4AF37] scale-125 shadow-[0_0_10px_rgba(212,175,55,0.5)]"
                                : "bg-[#D4AF37]/30"
                        }`}
                    ></button>
                ))}
            </div>
        </section>
    );
}

